import { Outlet, useMatches } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import './OpenCard.scss';

const OpenCard = () => {
	const matches = useMatches();

	const currentHeader = [...matches].reverse().find(m => m.handle?.header)?.handle.header || '';

	return (
		<div className='OpenCard'>
			<PageHeader header={currentHeader} />
			<div className='OpenCard__body'>
				<Outlet />
			</div>
		</div>
	);
};

export default OpenCard;
